export default "__VITE_ASSET__CZXQ0hSe__"